import {
  POST_FOLLOW_CALL_APPOINTMENT_REQUEST,
  POST_FOLLOW_CALL_APPOINTMENT_SUCCESS,
  POST_FOLLOW_CALL_APPOINTMENT_FAILURE,
} from '../../constants/ActionTypes'
import { questionnaireApi } from '../api/QuestionnaireApi';
import { push } from "react-router-redux";

export const postFollowCallAppointmentRequest = (id, data) => ({
  type: POST_FOLLOW_CALL_APPOINTMENT_REQUEST,
  payload: {
    id: id,
    data: data,
  }
});

export const postFollowCallAppointmentSuccess = () => ({
  type: POST_FOLLOW_CALL_APPOINTMENT_SUCCESS,
});

export const postFollowCallAppointmentFailure = (error) => ({
  type: POST_FOLLOW_CALL_APPOINTMENT_FAILURE,
  payload: {
    error: error,
  },
});

export function postFollowCallAppointment(id, data = {}) {
  return async (dispatch) => {
    dispatch(postFollowCallAppointmentRequest(id, data));

    questionnaireApi.postFollowCallAppointment(id, data, dispatch)
      .then(() => {
        dispatch(postFollowCallAppointmentSuccess());

        dispatch(
          push(`/questionnaires/follow-call-appointment/${id}/thank-you`, {
            questionnaireComplete: true,
          })
        );
      })
      .catch((error) => {
        dispatch(postFollowCallAppointmentFailure(error.response));
      });
  };
}


// WEBPACK FOOTER //
// ./src/redux/actions/FollowCallAppointment.js